import React from 'react';
import PropTypes from 'prop-types';
import { Platform, StyleSheet, View } from 'react-native';

import { createContainer } from '@dbk-legacy/muster/react';
import { pure } from '@dbk/ui-react-utils';

import SwitchIcons from '../../../../common/components/portfolio/portfolio-header-switch';
import { PALETTE } from '../../../../constants';

import MarketValueHeader from '../../../../components/common/market-value-header';
import NetIncome from '../net-income';

import PortfolioSwitch from '../portfolio-switch';

function PortfolioHeader({
  portfolio,
  portfolios,
  onPressNetIncome,
  changePortfolio,
  state,
  messages,
  portfolioChartYTD,
  location,
  ...props
}) {
  const {
    referenceCurrency,
    overallMarketValue,
    dayChange,
    netIncome,
    twrr,
  } = portfolio;

  function handleSwitchChanged(index) {
    state.view.setSelected(viewOptions[index].value);
  }

  const viewOptions = (state && state.view && state.view.options) || [];
  const selectedView = (state && state.view && state.view.selectedId) || null;
  const { primaryActive: activeIconFill, textColor: iconFill } = PALETTE;
  return (

    <div className="clearfix">
      {/* <PortfolioDismissableBar portfolio={portfolio}>
        <Text type="secondary">
          {messages['app.portfolio.portHeader.text']} <SimpleDate renderProps={{ type: 'secondary' }} value={overallMarketValue.asOfDate} /> {messages['app.portfolio.portHeader.endText']}
        </Text>
      </PortfolioDismissableBar> */}
      <div>
        <div
          className="column"
          style={{width: "70%" , marginBottom: "2.5%"}}
        >
          <MarketValueHeader
            marketValue={overallMarketValue.value}
            marketValueAsOfDate={overallMarketValue.asOfDate}
            marketValueUnit={referenceCurrency}
            dayChange={dayChange.value}
            dayChangeUnit={referenceCurrency}
            dayChangePercentage={dayChange.percent}
            messages={messages}
            twrr={portfolioChartYTD}
            location = {location}
          />
        </div>
        {/* <div className="small-12 medium-7 column">
          <NetIncome
            netIncome={netIncome.value}
            netIncomeUnit={referenceCurrency}
            onPress={onPressNetIncome}
          />
        </div> */}
      </div>
      <div className={'show-for-small-only portfolio-switch'}>
        <SwitchIcons
          iconFill={iconFill}
          activeIconFill={activeIconFill}
          options={viewOptions}
          selectedView={selectedView}
          onSwitch={handleSwitchChanged}
          messages={messages}/>
      </div>
    </div>
  );
}

PortfolioHeader.propTypes = {
  portfolio: PropTypes.shape({
    id: PropTypes.string,
    referenceCurrency: PropTypes.string.isRequired,
    overallMarketValue: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
    dayChange: PropTypes.shape({
      value: PropTypes.number.isRequired,
      percent: PropTypes.number.isRequired,
    }).isRequired,
    netIncome: PropTypes.shape({
      value: PropTypes.number,
    }),
  }).isRequired,
  portfolios: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  state: PropTypes.shape({
    view: PropTypes.shape({
      options: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string.isRequired,
        })
      ),
      selectedId: PropTypes.string,
      setSelected: PropTypes.func.isRequired,
    }),
  }).isRequired,
  onPressNetIncome: PropTypes.func.isRequired,
  changePortfolio: PropTypes.func,
  screen: PropTypes.shape({
    isSmall: PropTypes.bool,
  }),
};

export default createContainer({
  $fragments: {
    portfolio: {
      id: true,
      referenceCurrency: true,
      overallMarketValue: { value: true, asOfDate: true },
      dayChange: { value: true, percent: true },
      netIncome: { value: true },
      // ...PortfolioDismissableBar.getFragment('portfolio'),
    },
    state: {
      view: {
        options: true,
        selectedId: true,
        setSelected: { $set: 'selectedId' },
      },
    },
    portfolios: {
      ...PortfolioSwitch.getFragment('portfolios'),
    },
  },
})(pure(PortfolioHeader));

export { PortfolioHeader };
